import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function QuestionSunExposurePage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.v1.questionSunExposure.heading')}
      subheading={t('pages.onboarding.v1.questionSunExposure.subheading')}
      buttons={[
        {
          text: t('pages.onboarding.v1.questionSunExposure.button1'),
          value: 'outdoors_often',
        },
        {
          text: t('pages.onboarding.v1.questionSunExposure.button2'),
          value: 'moderate_outdoor',
        },
        {
          text: t('pages.onboarding.v1.questionSunExposure.button3'),
          value: 'minimal_indoors',
        },
        {
          text: t('pages.onboarding.v1.questionSunExposure.button4'),
          value: 'wear_spf',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
